"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const db_mapper_1 = __importDefault(require("../base/db-mapper"));
const report_model_1 = __importDefault(require("./report.model"));
class ReportMapper extends db_mapper_1.default {
    loadWithSort(companyID, ID) {
        return super.load(ID);
        // console.log('this.name', this.name);
        // return new Promise((resolve, reject) => {
        //     const params = {
        //         TableName: this.getDBName()!,
        //         Key: { ID: ID }, // removed , companyID: companyID from key object
        //     };
        //     this.db.get(params, (err, data) => {
        //         if (err) {
        //             console.log(
        //                 `Error loading ${this.name} with companyID ${companyID} ` +
        //                     `and ID ${ID} the error is:`,
        //                 err
        //             );
        //             return reject(err);
        //         }
        //         if (!data.Item) {
        //             console.log(
        //                 `${this.name} with companyID ${companyID} and ` + `ID ${ID} does not exist`
        //             );
        //             return resolve();
        //         }
        //         console.log(
        //             `successfully loaded ${this.name} with companyID ${companyID} ` +
        //                 `and reportID ${ID}`
        //         );
        //         const result = this.newModel(data.Item);
        //         return resolve(result);
        //     });
        // });
    }
}
exports.default = db_mapper_1.default.registerModel('report', report_model_1.default, ReportMapper);
